import 'url-search-params-polyfill';

const revalidate = (response, context = null) => {
    let params = { revalidateToken: response.token, context: context, ...response.revalidate }
    params = Object.keys(params).reduce((object, key) => {
        if (params[key] !== null && params[key].length) {
            object[key] = params[key];
        }
        return object
    }, {});
    const urlSearchParams = new URLSearchParams(params);
    window.localStorage.setItem('authenticated', 'false');
    window.location = '/auth?' + urlSearchParams.toString();
}

export default revalidate;